import { Assets as Assets_Provider } from 'src/api/assetProvider/AssetProvider.class';
import { Assets as Assets_Data } from './data';
import { Assets as Assets_Types } from './types';

export namespace Assets {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export import Types = Assets_Types.Types;
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  export import Data = Assets_Data.Data;
  export type AssetProvider = Assets_Provider.AssetProvider;
}
